import { OverlayModule } from '@angular/cdk/overlay'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatTableModule } from '@angular/material/table'
import { MatTooltipModule } from '@angular/material/tooltip'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { CptDialogModule } from '../cpt-dialog/cpt-dialog.module'
import { ProductsSelectorModule } from '../products-selector'
import { ProceduresCardComponent } from './procedures-card.component'

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    FlexLayoutModule,
    OverlayModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatTableModule,
    ProductsSelectorModule,
    CptDialogModule,
    TranslateModule,
  ],
  declarations: [
    ProceduresCardComponent,
  ],
  exports: [ProceduresCardComponent],
})
export class ProceduresCardModule {}
